// UserProfileDetails.tsx
import React from "react";
import { User } from "../../../types/admin/UserTypes";
import { Input, DatePicker, Select, Col, Typography } from "antd";
import dayjs from "dayjs";

const { Text } = Typography;

interface UserProfileDetailsProps {
	user: User;
	isEditing: boolean;
	setUserData: React.Dispatch<React.SetStateAction<User>>;
}

const UserProfileDetails: React.FC<UserProfileDetailsProps> = ({ user, isEditing, setUserData }) => {
	const genders = ["Male", "Female", "Other"];

	const handleChange = (name: keyof User, value: any) => {
		setUserData((prevUser) => ({ ...prevUser, [name]: value }));
	};

	return (
		<>
			<Col xs={24} sm={12} md={8}>
				<Text type="secondary" style={{ fontSize: 11 }}>Username</Text>
				{isEditing ? (
					<Input value={user.username || ""} onChange={(e) => handleChange("username", e.target.value)} placeholder="Enter username" style={{ marginTop: 4 }} />
				) : (
					<Text style={{ fontSize: 13, display: "block", marginTop: 4 }}>{user.username || "—"}</Text>
				)}
			</Col>

			<Col xs={24} sm={12} md={8}>
				<Text type="secondary" style={{ fontSize: 11 }}>Date of Birth</Text>
				{isEditing ? (
					<DatePicker value={user.date_of_birth ? dayjs(user.date_of_birth) : null} onChange={(date) => handleChange("date_of_birth", date?.toDate())} style={{ width: "100%", marginTop: 4 }} />
				) : (
					<Text style={{ fontSize: 13, display: "block", marginTop: 4 }}>{user.date_of_birth ? new Date(user.date_of_birth).toLocaleDateString("en-AU") : "—"}</Text>
				)}
			</Col>

			<Col xs={24} sm={12} md={8}>
				<Text type="secondary" style={{ fontSize: 11 }}>Gender</Text>
				{isEditing ? (
					<Select value={user.gender || undefined} onChange={(value) => handleChange("gender", value)} placeholder="Select gender" style={{ width: "100%", marginTop: 4 }}>
						{genders.map((g) => (
							<Select.Option key={g} value={g}>
								{g}
							</Select.Option>
						))}
					</Select>
				) : (
					<Text style={{ fontSize: 13, display: "block", marginTop: 4 }}>{user.gender || "—"}</Text>
				)}
			</Col>
		</>
	);
};

export default UserProfileDetails;
